import React from 'react';
import {
  Button,
  ButtonGroup,
  DialogActions,
  DialogContent,
  List,
  ListItem,
  ListItemText
} from "@material-ui/core";
import {EditModalTabs} from "../EditClientDialog";
import {Portfolio} from "../../../../../api/api";

export interface MenuEditClientDialogProps {
  brokerP: Portfolio,
  clientP: Portfolio,
  onActive: (active: EditModalTabs) => void,
  onCancel: () => void
}

export const MenuEditClientDialog = (p: MenuEditClientDialogProps) => {

  return (
    <>
      <DialogContent>
        <List component="nav">
          {p.brokerP && (
            <ListItem button onClick={() => p.onActive(EditModalTabs.BF_PORTFOLIO)}>
              <ListItemText primary="Broker Portfolio" secondary={p.brokerP?.name}/>
            </ListItem>
          )}
          {p.clientP && (
            <ListItem button onClick={() => p.onActive(EditModalTabs.CLIENT_PORTFOLIO)}>
              <ListItemText primary="Client Portfolio" secondary={p.clientP?.name}/>
            </ListItem>
          )}
        </List>
      </DialogContent>
      <DialogActions>
        <ButtonGroup variant='outlined'>
          <Button onClick={p.onCancel}>
            Cancel
          </Button>
        </ButtonGroup>
      </DialogActions>
    </>
  );
};
